import { Menu } from '@/components/organisms/Menu/Menu'
import React from 'react'
import Image from 'next/image'
import about from '@/styles/about/index.module.scss'

import { Footer } from '@/components/organisms/Footer/Footer'
export default function index () {
  return (
    <>

      <Menu />

      <div className={about.image_with_title_container}>
        <div className={about.image_container}>
          <Image
            src='/img/about/nosotros.png'
            className={about.logo1}
            alt='Picture of the author '
            width={500}
            height={500}
          />
        </div>
        <div className={about.title_container}>
          <h2 className={about.title1}>Sobre BASYS</h2>
          <p className={about.text}>Somos una empresa 100% mexicana enfocada en proveer soluciones administrativas y de control para la industria del reciclaje, BASYS es el más completo sistema administrativo y punto de venta especializado para recicladoras, chatarreras y compra venta de materiales reciclados, cientos de recicladores completamente satisfechos lo garantizan.</p>
          <p className={about.text}>“ENTENDEMOS TUS PROCESOS ADMINISTRATIVOS Y TE AYUDAMOS A FACILITARLOS”</p>
        </div>
      </div>
      <Footer />
    </>
  )
}
